module.exports = __webpack_public_path__ + "static/blog_larg_img-5a0b301c522c6622a9589f11bec8ab99.png";